var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCongrats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 267,
    viewBox: "0 0 167 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_87_533",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 6,
    width: 101,
    height: 252
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.898 6.3194H32.041V257.305H132.898V6.3194Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_87_533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2641 195.504C88.1342 195.548 88.0101 195.588 87.8791 195.625C84.352 196.63 32.041 211.064 32.041 182.535C32.041 153.009 50.9052 130.301 83.7256 130.501L91.6487 130.55C113.53 130.681 128.356 152.626 131.042 167.549C133.728 182.473 132.193 192.503 120.682 194.037C109.17 195.571 88.0653 189.436 90.7516 183.685C93.4379 177.933 119.531 179.467 120.074 179.43C120.618 179.393 118.761 176.665 117.12 176.654C115.479 176.645 114.141 177.87 114.131 179.394L113.694 250.994C113.686 252.317 112.784 253.472 111.493 253.775C101.418 256.141 90.8573 257.368 79.9783 257.302C71.9902 257.254 64.937 256.51 57.5182 255.133C56.1488 254.879 55.1703 253.674 55.1791 252.282L55.6009 186.048C55.6116 184.273 54.2936 182.546 52.3793 182.535C51.5298 182.529 49.693 183.301 49.693 185.218C49.693 187.136 79.6234 181.384 90.7516 178.316C101.83 175.263 103.02 190.451 88.2641 195.504Z",
    fill: "#5C4691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.58 79.6324C120.291 100.638 104.876 118.831 84.1482 120.268C63.421 121.705 44.2397 105.838 42.5281 84.8324C40.8164 63.8281 57.2222 45.6408 77.9494 44.2027C98.6775 42.7656 116.868 58.6281 118.58 79.6324Z",
    fill: "#5C4691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8784 102.396C70.6502 106.695 77.0469 108.996 79.8486 109.214C83.5299 109.501 86.8698 109.214 91.902 105.595",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.503 172.028C112.708 171.846 90.4668 162.881 87.9628 153.863C87.9094 153.67 87.6146 153.648 87.5458 153.836L68.4663 205.927C68.1346 206.832 69.1742 207.616 69.9432 207.033C86.7428 194.313 114.278 172.205 113.503 172.028Z",
    fill: "#FFB84E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4375 167.934C87.6404 169.885 104.19 169.73 109.747 175.463",
    stroke: "#FCE9CC",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2241 163.088C89.4207 165.061 106.712 165.345 113.186 172.518",
    stroke: "#FCE9CC",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6812 172.45C85.884 174.4 98.2672 172.468 106.214 179.214",
    stroke: "#FCE9CC",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4292 176.149C84.6321 178.1 94.1301 175.297 102.076 182.042",
    stroke: "#FCE9CC",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.687 180.665C82.8899 182.615 89.5019 178.725 97.4483 185.47",
    stroke: "#FCE9CC",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1163 166.354C105.321 171.404 112.338 173.813 113.789 171.736C115.24 169.659 110.576 163.882 103.371 158.833C96.167 153.784 89.1502 151.374 87.6991 153.451C86.2479 155.528 90.9118 161.305 98.1163 166.354Z",
    fill: "#F7CF94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.119 163.858C110.963 165.478 106.823 166.076 104.897 166.173V167.33C105.475 167.426 107.411 167.729 110.097 166.752C113.274 165.594 113.557 165.056 113.852 162.99C114.141 160.964 112.628 160.386 113.274 160.386C113.563 160.386 115.297 161.254 116.741 160.964C117.675 160.777 118.474 158.94 118.763 157.782L117.896 156.915C117.896 156.915 117.896 156.798 116.741 158.65C115.297 160.964 114.141 158.072 112.119 159.229C110.097 160.386 113.563 161.833 112.119 163.858Z",
    fill: "#EADCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8031 153.407C97.6196 152.13 97.4325 147.972 97.2366 146.053L97.929 145.96C98.0628 146.526 98.4982 148.424 98.2665 151.169C97.993 154.415 97.7088 154.739 96.5121 155.197C95.3397 155.644 94.7946 154.188 94.88 154.829C94.9178 155.116 95.6645 156.768 95.682 158.225C95.6927 159.168 94.6986 160.107 94.045 160.486L93.4117 159.694C93.4117 159.694 93.3429 159.704 94.2981 158.409C95.4919 156.791 93.6096 155.874 94.0353 153.774C94.462 151.675 95.7829 155.001 96.8031 153.407Z",
    fill: "#3D2F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.482 150.729C106.179 148.925 110.092 147.152 111.962 146.492L111.647 145.45C111.052 145.534 109.064 145.837 106.686 147.519C103.872 149.508 103.74 150.078 104.011 152.028C104.277 153.939 105.923 154.01 105.288 154.202C105.003 154.288 103.061 154.022 101.718 154.713C100.849 155.16 100.562 157.054 100.592 158.184L101.681 158.708C101.681 158.708 101.712 158.812 102.346 156.799C103.14 154.283 105.064 156.546 106.739 154.902C108.415 153.256 104.61 152.984 105.482 150.729Z",
    fill: "#EADCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.586 161.899L105.186 160.963L107.208 162.166L103.741 162.7L102.586 161.899Z",
    fill: "#8C7DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.113 157.788L108.169 155.148L111.085 155.55L107.857 158.164L106.113 157.788Z",
    fill: "#8C7DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.66 148.483C118.357 146.679 122.271 144.907 124.14 144.247L123.825 143.203C123.231 143.289 121.243 143.592 118.864 145.273C116.05 147.263 115.919 147.833 116.189 149.781C116.456 151.693 118.102 151.764 117.466 151.957C117.181 152.043 115.24 151.777 113.897 152.468C113.028 152.914 112.741 154.809 112.771 155.938L113.86 156.462C113.86 156.462 113.891 156.567 114.525 154.554C115.318 152.037 117.241 154.301 118.918 152.656C120.594 151.011 116.788 150.739 117.66 148.483Z",
    fill: "#3D2F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.275 149.681L102.875 147.655L104.897 150.259L101.431 151.416L100.275 149.681Z",
    fill: "#8C7DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.165 150.956L109.608 148.288L112.368 148.979L109.839 151.515L108.165 150.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.428 156.966L98.1686 158.899L95.8169 157.489L99.0492 155.987L100.428 156.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.314 156.023L112.98 157.325L111.528 156.299L113.458 155.317L114.314 156.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8673 178C79.8164 179.176 63.2108 184.37 54.9957 185.718C52.453 190.618 48.6 199.463 54.7019 200.051C62.3302 200.786 79.0531 196.376 87.2682 189.761C92.2878 185.718 86.6805 176.53 82.8673 178Z",
    fill: "#5C4691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1894 171.565C98.6032 172.86 109.258 178.133 115.759 179.617C117.771 185.012 120.588 193.157 115.759 193.805C109.723 194.614 100.026 192.271 91.2406 185.454C86.5265 181.796 93.1714 169.947 96.1894 171.565Z",
    fill: "#5C4691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7634 56.7103C63.6123 56.7103 79.0251 48.486 85.3791 44.5467L48.5273 6.3194C49.7978 25.4331 52.7634 56.7103 52.7634 56.7103Z",
    fill: "#F6CF94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3459 55.7413C52.0834 74.3152 51.4366 112.819 66.9531 118.245",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2207 28.1416C51.4455 28.1416 59.7197 21.3214 59.7197 17.9297L64.0256 22.3932C65.84 24.2063 56.4826 32.6865 50.6639 33.6555C50.5058 31.9946 50.2207 28.1416 50.2207 28.1416Z",
    fill: "#F3B354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0117 48.6109C67.279 43.7017 68.0713 44.193 76.3988 35.3698L81.4019 40.2858C83.2164 42.0989 65.7409 55.593 52.5693 54.1249C52.4113 52.4639 52.0117 48.6109 52.0117 48.6109Z",
    fill: "#F3B354"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4038 18.2291C49.4038 18.2291 53.4214 18.6775 56.4256 14.5445C56.4271 14.5426 58.0882 16.2479 58.0882 16.2479C58.0882 16.2479 56.9589 19.9115 49.6598 21.3254C49.6482 21.3277 49.4038 18.2291 49.4038 18.2291Z",
    fill: "#FCE9CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9673 36.8252C50.9673 36.8252 65.0921 38.1941 68.1899 26.7209C68.1918 26.7144 71.4133 29.8973 71.4133 29.8973C71.4133 29.8973 77.0221 37.591 51.6806 44.7103C51.6527 44.7187 50.9673 36.8252 50.9673 36.8252Z",
    fill: "#FCE9CC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/Congrats.331685be5b1d27a601db98ff33135148.svg";
export { ForwardRef as ReactComponent };